export const MULTIMEDIA_GET_FILES = 'MULTIMEDIA_GET_FILES';
export const MULTIMEDIA_GET_FILES_SUCCESS = 'MULTIMEDIA_GET_FILES_SUCCESS';
export const MULTIMEDIA_GET_FILES_FAILURE = 'MULTIMEDIA_GET_FILES_FAILURE';

export const MULTIMEDIA_CREATE_FILE = 'MULTIMEDIA_CREATE_FILE';
export const MULTIMEDIA_CREATE_FILE_SUCCESS = 'MULTIMEDIA_CREATE_FILE_SUCCESS';
export const MULTIMEDIA_CREATE_FILE_FAILURE = 'MULTIMEDIA_CREATE_FILE_FAILURE';

export const MULTIMEDIA_EDIT_FILE = 'MULTIMEDIA_EDIT_FILE';
export const MULTIMEDIA_EDIT_FILE_SUCCESS = 'MULTIMEDIA_EDIT_FILE_SUCCESS';
export const MULTIMEDIA_EDIT_FILE_FAILURE = 'MULTIMEDIA_EDIT_FILE_FAILURE';

export const MULTIMEDIA_REMOVE_FILE = 'MULTIMEDIA_REMOVE_FILE';
export const MULTIMEDIA_REMOVE_FILE_SUCCESS = 'MULTIMEDIA_REMOVE_FILE_SUCCESS';
export const MULTIMEDIA_REMOVE_FILE_FAILURE = 'MULTIMEDIA_REMOVE_FILE_FAILURE';

export const MULTIMEDIA_SELECT_FILE = 'MULTIMEDIA_SELECT_FILE';
export const MULTIMEDIA_UNSELECT_FILE = 'MULTIMEDIA_UNSELECT_FILE';
export const MULTIMEDIA_SELECT_FILES = 'MULTIMEDIA_SELECT_FILES';

export const MULTIMEDIA_PROPS_CHANGED = 'MULTIMEDIA_PROPS_CHANGED';
